module.exports = __webpack_public_path__ + "img/202405_03.4eb14eee.jpg";